"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
class UserStatus {
    constructor(value) {
        this.value = value || UserStatus.UNKNOWN.toString();
    }
    toString() {
        return this.value;
    }
    valueOf() {
        return this.value;
    }
}
exports.UserStatus = UserStatus;
UserStatus.UNKNOWN = new UserStatus('UNKNOWN'); // default status (pre-request)
UserStatus.NO_SESSION = new UserStatus('NO_SESSION'); // user is not logged in
UserStatus.ACTIVE = new UserStatus('ACTIVE'); // user is logged in and has an active account in SCT
UserStatus.INACTIVE = new UserStatus('INACTIVE'); // user is logged in but their SCT account is not active
UserStatus.REGISTERING = new UserStatus('REGISTERING'); // user exists in DCI but not in SCT
//# sourceMappingURL=user-status-enum.js.map